export default {
  templateTar: 'http://srm-file-public-prod.oss-cn-shanghai.aliyuncs.com/1573d5b1-7913-4d80-b339-74c5c3c10fa6.rar' // 参照范本
}
